import { render, staticRenderFns } from "./FaceTemplate.vue?vue&type=template&id=1a0b8b7b"
import script from "./FaceTemplate.vue?vue&type=script&lang=js"
export * from "./FaceTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports